export var PRODUCT_SEGMENT = "Product segment : ";
export var PRODUCT_TITLE = "Product title : ";
export var REQUIRED = "* Required field";
export var CANCEL = "Cancel";
export var SUBMIT = "Open ticket";
export var API_ERROR_MSG = "There’s a technical issue on our end. The good news is we’re working on it. Try again.";